export const datePickerDataLocators = {
    rangepicker_start_date_test_id: 'rangepicker_start_date_test_id',
    rangepicker_end_date_test_id: 'rangepicker_end_date_test_id'
};
